export const membershipForm = {
	init: () => {
		const form = document.querySelector( '.membership-form' );
		if ( ! form ) {
			return;
		}
		updateElementsDisplay( form );
		form.querySelectorAll( 'input' ).forEach( ( elmt ) => {
			elmt.addEventListener( 'change', () => {
				updateElementsDisplay( form );
				updateMembershipSummary( form );
			} );
		} );
		form.classList.remove( 'hidden' );
	},
};

function getActiveElementsSelector( form, selector ) {
	const allClasses = [];
	const classParts = [];
	classParts.push( form.querySelector( 'input[name=cat]' ).value );
	allClasses.push( selector + '.' + classParts.join( '-' ) );
	const membershipTypeOption = form.querySelector( 'input[name="membership_type"]:checked' );
	if ( membershipTypeOption ) {
		classParts.push( membershipTypeOption.value );
		allClasses.push( selector + '.' + classParts.join( '-' ) );
	}
	return allClasses.join( ', ' );
}

function updateElementsDisplay( form ) {
	const selector = '.conditional-display';
	const activeElementsSelector = getActiveElementsSelector( form, selector );
	const conditionalElements = form.querySelectorAll( selector );
	const activeConditionalElements = form.querySelectorAll( activeElementsSelector );
	const inactiveConditionalElements = [ ...conditionalElements ].filter( ( x ) => ! [ ...activeConditionalElements ].includes( x ) );
	inactiveConditionalElements.forEach( ( elmt ) => {
		elmt.classList.add( 'hidden' );
		const inputs = elmt.querySelectorAll( 'input' );
		inputs.forEach( ( input ) => {
			input.checked = false;
		} );
	} );
	activeConditionalElements.forEach( ( elmt ) => {
		elmt.classList.remove( 'hidden' );
	} );
}

function updateMembershipSummary( form ) {
	updatePriceSummary( form );
	updateMembershipDetailsSummary( form );
	updateOptionsSummary( form );
}

function updateMembershipDetailsSummary( form ) {
	const detailsElmts = form.querySelectorAll( 'input[data-summary-type="detail"]:checked' );
	const detailsSummaryContainer = form.querySelector( '.membership-summary' );
	detailsSummaryContainer.innerHTML = '';
	if ( ! detailsElmts ) {
		return;
	}
	const recap = getRecap( form );
	recap.details = [];
	detailsElmts.forEach( ( elmt ) => {
		const detailElmt = document.createElement( 'li' );
		detailElmt.innerHTML = elmt.dataset.shortName;
		recap.details.push( elmt.dataset.shortName );
		detailsSummaryContainer.appendChild( detailElmt );
	} );
	setRecap( form, recap );
}

function updateOptionsSummary( form ) {
	const optionsElmts = form.querySelectorAll( 'input[data-summary-type="option"]:checked' );
	const optionsSummaryContainer = form.querySelector( '.options-summary' );
	const optionsSummaryTitleElmt = form.querySelector( '.membership-summary-container .options-title' );
	optionsSummaryContainer.innerHTML = '';
	if ( optionsElmts.length > 0 ) {
		optionsSummaryTitleElmt.classList.remove( 'hidden' );
	} else {
		optionsSummaryTitleElmt.classList.add( 'hidden' );
	}
	const recap = getRecap( form );
	recap.options = [];
	optionsElmts.forEach( ( elmt ) => {
		const optionElmt = document.createElement( 'li' );
		optionElmt.innerHTML = elmt.dataset.shortName;
		recap.options.push( elmt.dataset.shortName );
		optionsSummaryContainer.appendChild( optionElmt );
	} );
	setRecap( form, recap );
}

function updatePriceSummary( form ) {
	let priceHt = getActiveOptionsPrice( form );
	priceHt = applyPriceModifiers( form, priceHt );
	let priceTtc = getPriceTtcFromHt( priceHt );
	if ( priceHt === 0 ) {
		priceHt = '-';
	}
	if ( priceTtc === 0 ) {
		priceTtc = '-';
	}
	const priceHtElement = form.querySelector( '.price-summary .price .price-ht .value' );
	const priceTtcElement = form.querySelector( '.price-summary .price .price-ttc .value' );
	priceHtElement.innerHTML = priceHt;
	priceTtcElement.innerHTML = priceTtc;
	const recap = getRecap( form );
	recap.price = {};
	recap.price.ht = priceHt;
	recap.price.ttc = priceTtc;
	setRecap( form, recap );
}

function getActiveOptionsPrice( form ) {
	let price = 0.00;
	const priceElements = form.querySelectorAll( 'input[data-price]:checked' );
	priceElements.forEach( ( elmt ) => {
		const thisPrice = parseFloat( elmt.dataset.price );
		price += thisPrice;
	} );
	return price;
}

function getPriceTtcFromHt( priceHt ) {
	const priceTtc = priceHt + ( priceHt * 20 / 100 );
	return Math.round( priceTtc * 100 ) / 100;
}

function applyPriceModifiers( form, price ) {
	let modifier = 0;
	const hasRcFranceOption = form.querySelector( 'input[name="rc_france"]:checked' );
	const hasEngagementOption = form.querySelector( 'input[name="engagement"]:checked' );
	if ( hasRcFranceOption ) {
		modifier -= 10;
	}
	if ( hasEngagementOption ) {
		modifier -= 10;
	}
	const modifiedPrice = price + ( price * modifier / 100 );
	return Math.round( modifiedPrice * 100 ) / 100;
}

function getRecap( form ) {
	const recapDataField = form.querySelector( 'input[name=recap]' );
	return recapDataField.value ? JSON.parse( decodeURIComponent( escape( atob( recapDataField.value ) ) ) ) : {};
}

function setRecap( form, recap ) {
	const recapDataField = form.querySelector( 'input[name=recap]' );
	recapDataField.value = btoa( unescape( encodeURIComponent( JSON.stringify( recap ) ) ) );
}
